"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var openStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transform: translate(0, 0);\n\n  @media (min-width: ", ") {\n    transform: translate(-50%, 0);\n  }\n"])), function (props) {
  return props.theme.screenWidthMd;
});

var StyledWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: ", ";\n  left: 0;\n  bottom: 0;\n  height: 98%;\n  width: 100%;\n  padding: 0 1rem 1rem;\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n  background: white;\n  transform: translate(0, 100%);\n  transition: transform 0.575s;\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    margin: 0 auto;\n    transform: translate(-50%, 100%);\n  }\n\n  ", ";\n"])), function (p) {
  return p.position;
}, function (p) {
  return p.theme.zIndexSlideUpDialog || 1;
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.theme.railWidth;
}, function (p) {
  return p.isOpen && openStyles;
});

var StyledToggleButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 2rem;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  &:disabled {\n    cursor: default;\n  }\n"])));

var StyledToggleButtonIcon = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  width: 3rem;\n  height: 6px;\n  border-radius: 2px;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorLightGrey;
});

var Wrapper = function Wrapper(_ref) {
  var isOpen = _ref.isOpen,
      isCloseable = _ref.isCloseable,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "fixed" : _ref$position,
      children = _ref.children,
      onCloseClicked = _ref.onCloseClicked,
      className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    className: className,
    isOpen: isOpen,
    position: position,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledToggleButton, {
      disabled: !isCloseable,
      onClick: onCloseClicked,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledToggleButtonIcon, {})
    }), children]
  });
};

var _default = Wrapper;
exports.default = _default;